import { SORT_ORDER, TableSortOption } from '@evinced-private/ui-common';

const DASHBOARD_ISSUES_DEFAULT_SORT: TableSortOption = {
	dataField: 'issueType',
	order: SORT_ORDER.DESC
};

const DASHBOARD_ISSUES_SEVERITY_SORT_FIELDS = ['severity', 'severityName'];

type DashboardIssuesSortParams = {
	sort: TableSortOption;
	sortFields?: string[];
};

export const buildDashboardIssuesSortParams = (
	sort?: TableSortOption,
	shouldExpandSeveritySort = false
): DashboardIssuesSortParams => {
	const effectiveSort = sort ?? DASHBOARD_ISSUES_DEFAULT_SORT;

	return {
		sort: effectiveSort,
		sortFields:
			shouldExpandSeveritySort && effectiveSort.dataField === 'severity'
				? DASHBOARD_ISSUES_SEVERITY_SORT_FIELDS
				: undefined
	};
};
